import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Award, Shield, Target } from 'lucide-react';
import { Button } from '../ui/button';

const AccreditationSection = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-blue-50 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-700 text-sm font-semibold rounded-full mb-6">
              Accreditation
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Accredited by 
              <span className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent"> STEAM-IE</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              India&apos;s first Credentialing company for STEAM Education, Innovation & Entrepreneurship. 
              We are here to recognise you for your achievements. Tell your story to the world on our platform.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">School Accreditation</h4>
                  <p className="text-gray-600">If you are a school/organisation, we are here to assess and certify you as a STEAM-IE accredited institution.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-teal-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Educator Certification</h4>
                  <p className="text-gray-600">If you are an Educator, we are here to certify you as a STEAM-IE certified teacher.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Target className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Student Recognition</h4>
                  <p className="text-gray-600">Students receive digital badges and certificates for completing STEAM-IE programs.</p>
                </div>
              </div>
            </div>

            <Link to="/contact">
              <Button className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white px-8 py-6 rounded-full text-lg shadow-lg hover:shadow-xl transition-all duration-300 group">
                Get Accredited
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          {/* Right Visual */}
          <div className="relative">
            <div className="relative z-10 bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-500">
              {/* Badge Visual */}
              <div className="relative w-64 h-64 mx-auto mb-8">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-teal-500 rounded-full animate-pulse opacity-20"></div>
                <div className="absolute inset-4 bg-gradient-to-br from-blue-600 to-teal-500 rounded-full flex items-center justify-center">
                  <div className="bg-white rounded-full p-8">
                    <div className="text-center">
                      <div className="w-16 h-16 mx-auto bg-gradient-to-br from-blue-600 to-teal-500 rounded-xl flex items-center justify-center mb-3">
                        <span className="text-white font-bold text-2xl">S</span>
                      </div>
                      <p className="font-bold text-gray-800 text-lg">STEAM-IE</p>
                      <p className="text-sm text-gray-500">Certified</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <h4 className="text-xl font-bold text-gray-900 mb-2">Official Certification</h4>
                <p className="text-gray-600">Recognized nationwide for STEAM excellence</p>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-yellow-400/20 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-blue-400/20 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccreditationSection;
